import {
  FETCH_PRODUCT_UNIT,
  RESET_PRODUCT_UNIT,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const productUnitViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_UNIT:
      return { data: action.payload };
    case RESET_PRODUCT_UNIT:
      return initialState;
    default:
      return state;
  }
};

export default productUnitViewReducer;
